export function Logo({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" className="shrink-0">
      <rect width="64" height="64" rx="16" fill="#FF7A1A" />
      <circle cx="32" cy="34" r="17" fill="#FFF8F0" />
      <circle cx="32" cy="34" r="11" fill="#FFD24D" />
      <path d="M15 12v16M11 12v7a4 4 0 0 0 8 0v-7" stroke="#FFF8F0" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M51 12c-4 0-6 4-6 9v7M51 12v16" stroke="#FFF8F0" strokeWidth="3" strokeLinecap="round" fill="none" />
    </svg>
  );
}
